import React from 'react';
import { Box, CardMedia, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const BookFromAnywereWeb = () => (
  <>
    <Stack sx={{ px: '75px', py: 20, backgroundColor: 'white' }}>
      <Stack sx={{ flexDirection: 'row' }}>
        <Stack gap={2} width="50%" justifyContent="center" pl={8}>
          <Typography color="#121212" fontSize={46} fontWeight={700} lineHeight={1.2} mb={1}>
            Book From Anywhere,
            <br />
            Inspect Right There!{' '}
          </Typography>
        </Stack>
        <Stack width="50%" backgroundColor="#121212">
          <CardMedia
            component="img"
            className=""
            src="assets/images/Inspection/booked.webp"
            alt="Certified Focus"
            // height={isMobile ? 25 : 40}
            sx={{ objectFit: 'contain' }}
          />
        </Stack>
      </Stack>
      <Stack sx={{ flexDirection: 'row' }}>
        <Stack width="50%" backgroundColor="#c8c9c9">
          <CardMedia
            component="img"
            className=""
            src="assets/images/Inspection/notePadWeb.webp"
            alt="Note pade"
            // height={isMobile ? 25 : 40}
            sx={{ objectFit: 'contain' }}
          />
        </Stack>
        <Stack width="50%" justifyContent="center" pl={3}>
          <Stack sx={{ maxWidth: '500px', ml: 4 }} gap={0.5}>
            <Typography color="#121212" fontSize={19} fontWeight={400} lineHeight={1.2} mb={1}>
              📱 Easy online booking from your phone{' '}
            </Typography>
            <Typography fontSize="19px" color="#121212" fontWeight="400">
              📍 Inspection at car’s exact location
            </Typography>
            <Typography fontSize="19px" color="#121212" fontWeight="400">
              🎯 Precisely track your inspection status in real-time
            </Typography>
            <Box mt={4}>
              <FocusInspectionButtonWeb
                title="Inspect Your Inspection Now"
                subtitle="Inspection team will contact you soon."
                subTitleColor="#121212"
                // onClick={() => console.log('Button clicked')}
              />
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  </>
);

export default BookFromAnywereWeb;
